import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Icon from 'widgets/Icon/Icon';

const ExpandableBar = ({ expanded, children, onElementClick }) => (
  <div className={classNames('gn-bar', 'gn-expandableBar')}>
    <div className="gn-expandableBar__wrapper">
      <button
        type="button"
        aria-expanded={expanded}
        onClick={onElementClick}
        className={classNames('gn-expandableBar__header', { 'gn-expandableBar__header--expanded': expanded })}
      >
        <span>{children}</span>
        <Icon name={expanded ? 'chevron-up' : 'chevron-down'} className="gn-expandableBar__icon" />
      </button>
    </div>
  </div>
);

ExpandableBar.propTypes = {
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  onElementClick: PropTypes.func,
};

export default ExpandableBar;
